import React from 'react'

type TAspectRatio =
  | 'auto'
  | 'golden'
  | 'landscape'
  | 'portrait'
  | 'square'
  | 'ultrawide'
  | 'video'

type TLoading = 'eager' | 'lazy'

type TProps = {
  alt?: string
  aspectRatio: TAspectRatio
  loading: TLoading
  src: string
}

const aspectRatioClassName = {
  auto: 'aspect-auto',
  golden: 'aspect-golden',
  landscape: 'aspect-landscape',
  portrait: 'aspect-portrait',
  square: 'aspect-square',
  ultrawide: 'aspect-ultrawide',
  video: 'aspect-video'
}

function Image({ alt = '', aspectRatio, loading = 'eager', src }: TProps) {
  return (
    <img
      alt={alt}
      src={src}
      className={`${aspectRatioClassName[aspectRatio]} size-full object-cover`}
      loading={loading}
    />
  )
}

export default Image
